<template>
  <path
    d="M5 18.0002H20C20.55 18.0002 21 17.5502 21 17.0002V13.0002C21 12.4502 20.55 12.0002 20 12.0002H5C4.45 12.0002 4 12.4502 4 13.0002V17.0002C4 17.5502 4.45 18.0002 5 18.0002ZM4 6.00024V10.0002C4 10.5502 4.45 11.0002 5 11.0002H20C20.55 11.0002 21 10.5502 21 10.0002V6.00024C21 5.45024 20.55 5.00024 20 5.00024H5C4.45 5.00024 4 5.45024 4 6.00024Z"
  />
</template>
